import { render, staticRenderFns } from "./IconVideoToggle.vue?vue&type=template&id=379eebe7&scoped=true"
import script from "./IconVideoToggle.vue?vue&type=script&lang=js"
export * from "./IconVideoToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379eebe7",
  null
  
)

export default component.exports